export const finish = {
  documents_count: 1,
  documents_signed_count: 1,
};
